import { combineReducers } from 'redux';

import { ServiceBookingProps } from '@/global/models/IServiceBooking';
import serviceBookingReducer from '@/store/redux/slices/pages/serviceBooking';

export interface ServiceBookingCombinedState {
  page: ServiceBookingProps;
}

const combinedReducers = combineReducers({
  page: serviceBookingReducer,
});

export default combinedReducers;
